import axios from 'axios';
import API_BASE_URL from '../config.js';

const getBanners = async (event) => {

    const response = await axios.get(`${API_BASE_URL}/banners/`,
    );

    return response.data;

};

export default getBanners 
